export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7702 - Fiche de spécifications et données techniques-4c0586ce5b3bb00534324f9a0d74365f.pdf";